var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.44,59.17c-3.46,18.44-18.08,33.29-36.32,37.4-.67.15-1.36.33-2.04.39v-33.47h10.29l2.17-13.19h-12.46v-10.47c0-2.74,2.14-4.72,4.69-5.19,2.71-.5,5.75-.06,8.51-.21v-12.09c-7.24-.91-15.09-2.15-21.53,2.14-8.85,5.91-7.16,16.23-7.25,25.5l-.15.32h-11.67v13.19h11.81v33.36c-.5.28-1.44-.05-2.05-.17C19.93,92.44,3.77,73.98,2.91,52.93l-.18-.97v-3.41C3.68,26.68,19.82,7.8,41.38,3.84c32.71-6,61.18,22.66,55.06,55.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.e2281811af421c140d4542d415c9a333.svg";
export { ForwardRef as ReactComponent };